<template>
  <div class="container">
    <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="icon" />
    <h2 class="title">{{ messageShown }}</h2>
    <p v-if="descriptionShown">{{ descriptionShown }}</p>
    <Button v-if="showAdminLink === 'true' && adminUrl" :href="adminUrl">{{ t('GO TO ADMIN') }}</Button>
  </div>
</template>

<script lang="ts">
import Button from '@/components/Button.vue';
import { computed, Ref } from 'vue';
import { sendRecordingErrorMessage } from '@/iframe-messaging';
import store from '@/store';
import { Answer } from 'altru-types';
import { useI18n } from 'vue-i18n';
import { getPrioritizedAdminOrigins } from '@/utils/adminOrigins';

export default {
  name: 'Error',
  components: { Button },
  props: {
    message: {
      type: String,
    },
    description: {
      type: String,
    },
    showAdminLink: {
      type: String,
    },
  },
  setup(props: { message: string; description: string; showAdminLink: boolean }): {
    t: (key: string) => string;
    adminUrl: Ref<string>;
    messageShown: Ref<string>;
    descriptionShown: Ref<string>;
  } {
    const { t } = useI18n();
    const isIframed: Ref<boolean> = computed(() => store.getters['status/isIframed']);
    const payloadAnswer: Ref<Answer> = computed(() => store.getters['answers/payloadAnswerInfo']);
    const adminUrl: Ref<string> = computed(() => getPrioritizedAdminOrigins()[0]);

    const messageShown: Ref<string> = computed(() => props.message || t('SOMETHING WENT WRONG'));
    const descriptionShown: Ref<string> = computed(() => props.description ?? '');

    // Emit error message to parent
    if (isIframed.value) {
      sendRecordingErrorMessage({
        kind: 'answer recording error',
        level: 'error',
        message: messageShown.value,
        answerId: payloadAnswer.value?.id,
      });
    }

    return {
      t,
      adminUrl,
      messageShown,
      descriptionShown,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  padding: 20px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .title {
    margin: 0;
    max-width: 656px;
  }

  .icon {
    height: auto;
    width: 56px;
    color: tomato;
  }

  p {
    white-space: pre-line;
    text-align: left;
    margin: 0;
  }
}
</style>
